import { Get, Remove, Set } from "../../../../../Request";

export const GetData = async (pageNumber, limit = 15, filter) => {
  return await Get({
    url: "/ticket/show_list_admin",
    data: {
      limit: limit,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const FormChatSubmit = async data => {
  return await Get({
    url: "/ticket/new_answer",
    data: data,
  }).then(result => {
    if (result) {
      return result;
    } else {
      return false;
    }
  });
};

export const GetTicket = async ticket_id => {
  return await Get({
    url: "/ticket/get_chat_singleticket",
    data: {
      ticket_id,
      // ticket_id:ticket_id,
    },
  }).then(data => {
    return data;
  });
};
